import template from 'url-template';

import { get } from 'lodash';

import awsHeader from '../helpers/awsAuth';
import k2aBaseApi from '../apis/key2act';

import { handleNetworkError } from './applicationMessageActions';

const ClientsUrl = template.parse('/companies/{companyId}/clients{?limit,page,searchFilter,sort}');
const EquipmentUrl = template.parse('/sites/{siteId}/equipment{?limit,page,searchFilter,sort}');
const SitesUrl = template.parse('/clients/{clientId}/sites{?limit,page,searchFilter,sort}');
const SystemsUrl = template.parse('/sites/{siteId}/systems{?searchFilter,limit,equipmentId}');

export const fetchNavigationClients = (companyId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();
    options.limit = 250;
    options.sort = 'name^asc';

    try {
        const response = await k2aBaseApi.get(
            ClientsUrl.expand({
                companyId,
                ...options
            }),
            header
        );

        const clients = get(response, 'data.data', []);

        return clients;
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchNavigationSites = (clientId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();
    options.limit = 250;
    options.sort = 'name^asc';

    try {
        const response = await k2aBaseApi.get(
            SitesUrl.expand({
                clientId,
                ...options
            }),
            header
        );

        const sites = get(response, 'data.data', []);

        return sites;
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchNavigationEquipment = (siteId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();
    options.limit = 250;
    options.sort = 'name^asc';

    try {
        const response = await k2aBaseApi.get(
            EquipmentUrl.expand({
                siteId,
                ...options
            }),
            header
        );

        const equipment = get(response, 'data.data', []);

        return equipment;
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchNavigationSystems = (siteId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();
    options.limit = 250;
    options.sort = 'name^asc';

    try {
        const response = await k2aBaseApi.get(
            SystemsUrl.expand({
                siteId,
                ...options
            }),
            header
        );

        const systems = get(response, 'data.data', []);

        return systems;
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};
